import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navItems, logoUrl } from '../mock';
import { getSite } from '../siteConfig';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const homeUrl = getSite('siteUrl', '/');
  const cta = getSite('header_cta', 'Let’s talk :)');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 transition-all ${scrolled ? 'bg-[#FFFCF5]/95 backdrop-blur border-b border-black/10' : 'bg-[#FFFCF5]'}`}>
      <div className="flex items-center justify-between px-4 md:px-8 py-3">
        <a href={homeUrl} className="flex items-center gap-2 group" aria-label="Home">
          <img src={logoUrl} alt="Social Potato" className="h-20 md:h-24 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map(item => <a key={item.label} href={item.href} className="nav-link text-sm font-medium">{item.label}</a>)}
        </nav>
        <a href="#contact" className="hidden lg:inline-flex items-center gap-2 btn-yellow px-5 py-2.5 border-2 border-black rounded-full font-semibold text-sm">{cta}</a>
        <button data-testid="mobile-nav-toggle" onClick={() => setOpen(!open)} className="lg:hidden p-2 border-2 border-black rounded-full bg-[#FFD200]" aria-label="Toggle navigation">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#FFFCF5] border-t border-black/10 px-6 py-4 flex flex-col gap-4">
          {navItems.map(item => <a key={item.label} href={item.href} onClick={() => setOpen(false)} className="text-lg font-medium">{item.label}</a>)}
          <a href="#contact" onClick={() => setOpen(false)} className="btn-yellow px-5 py-3 border-2 border-black rounded-full font-semibold text-center">{cta}</a>
        </div>
      )}
    </header>
  );
};
export default Header;
